import React, { useState } from "react";
import { footerAPI } from "./NikeStore/constents/Constents" 
import Footer from "./NikeStore/layouts/Footer";
import NavBar from "./NikeStore/layouts/NavBar";
import Home from "./NikeStore/pages/Home";
const App = () => {
  const [showCart, setShowCart] = useState(false)
  return (
    <> 
        <header className="container sticky top-0 max-w-[1600px] z-50 bg-blue-700">
          <NavBar showCart={showCart} setShowCart={setShowCart} />
        </header>
        <main className="container flex flex-col gap-4 overflow-hidden">
          <Home showCart={showCart} setShowCart={setShowCart} />
        </main>
        <footer className="w-full mt-5 bg-gradient-to-b from-blue-900 to-blue-400 flex justify-around">
          <Footer data={footerAPI} />
        </footer> 
    </>
  )
} 
// import NavBar from "./Blog-app/layout/NavBar";
// import { Routes, Route } from "react-router-dom"
// import { Home, DashBoardProfile, SignIn, SignUp } from "./Blog-app/pages";
// import Footer from "./Blog-app/layout/Footer";
// import { PrivateRoute } from "./Blog-app/components/PrivateRoute";
// import NotFind from "./Blog-app/pages/NotFind";
// import CreatePost from "./Blog-app/pages/CreatePost";
// import PrivateAdminRoute from "./Blog-app/components/PrivateAdminRoute";
// import UpdatePost from "./Blog-app/pages/UpdatePost";
 
// const App = () => {
//     return (
//         <>
//             <header className="px-2 lg:px-14">
//                 <NavBar />
//             </header>
//             <main className="px-4 overflow-x-hidden">
//                 <Routes>
//                     <Route path="/" element={<Home />}></Route>
//                     <Route path="/sign-up" element={<SignUp />}></Route>
//                     <Route path="/sign-in" element={<SignIn />}></Route>
//                     <Route element={<PrivateRoute />}>
//                         <Route path="/dashboard" element={<DashBoardProfile />}/>
//                     </Route>
//                     <Route element={<PrivateAdminRoute />}>
//                         <Route path="/create-post" element={<CreatePost />} />
//                         <Route path="/update-post/:postId" element={<UpdatePost />} />
//                     </Route>
//                     <Route path="*" element={<NotFind />} />
//                 </Routes>
//             </main>
//             <footer className="px-4">
//                 <Footer />
//             </footer>
//         </>
//     )
// }

export default App